exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carrier-table[data-v-00bd6cb5]{min-height:20rem;max-height:42rem}.with-full-radius[data-v-00bd6cb5]{color:#fff;font-weight:700;border-radius:5px}.t-bg-red[data-v-00bd6cb5]{background:red;border-color:red}.text-error[data-v-00bd6cb5]{color:red}", ""]);

// exports
